import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ContractState {
  documentTitle: string;
  contactName: string;
  contactTaxID: string;
  contactAddress: string;
  contactPhone: string;
  contactEmail: string;
  eventDate: string;
  notes: string;
}

const initialState: ContractState = {
  documentTitle: "חוזה אירוע",
  contactName: "יוסי כהן",
  contactTaxID: "123456789",
  contactAddress: "רחוב הרצל 123, תל אביב",
  contactPhone: "050-1234567",
  contactEmail: "yossi@example.com",
  eventDate: "2025-12-01",
  notes: "זהו חוזה לדוגמה עם פרטים מלאים",
};

const contractSlice = createSlice({
  name: "contract",
  initialState,
  reducers: {
    updateField: (
      state,
      action: PayloadAction<{ field: keyof ContractState; value: string }>
    ) => {
      const { field, value } = action.payload;
      state[field] = value;
    },
    resetContract: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const { updateField, resetContract } = contractSlice.actions;
export default contractSlice.reducer;
